// extracted by mini-css-extract-plugin
export default {"reminder":"SchoolCampaignReminder_reminder__85LP1"};